export const ModalTarget = 'modal-target';
